import React, { useEffect, useState } from 'react';
import Diploma from './Diploma';
import './diplomaPage.css';
import { Link, useSearchParams } from 'react-router-dom';

const DiplomaPage = () => {
  const [searchParams] = useSearchParams();
  const courseId = Number(searchParams.get('courseId')) || 1;

  // 'loading' | 'ready' | 'missing' | 'error'
  const [state, setState] = useState('loading');
  const [certificate, setCertificate] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setState('loading');

    fetch(`${process.env.REACT_APP_API_URL}/certificates/course/${courseId}`, {
      credentials: 'include'
    })
      .then(async (res) => {
        if (res.status === 404) {
          if (!cancelled) setState('missing');
          return;
        }
        if (!res.ok) throw new Error('Certificatul nu a putut fi incarcat');
        const data = await res.json();
        if (!cancelled) {
          setCertificate(data);
          setState('ready');
        }
      })
      .catch((error) => {
        console.error('Eroare la incarcarea certificatului:', error);
        if (!cancelled) setState('error');
      });

    return () => {
      cancelled = true;
    };
  }, [courseId]);

  if (state === 'loading') {
    return <div className="diploma-page" />;
  }

  if (state !== 'ready') {
    return (
      <div className="diploma-page">
        <div className="diploma-success">
          <h1>Certificat indisponibil</h1>

          <p>
            {state === 'missing'
              ? 'Nu exista inca un certificat pentru acest curs. Finalizeaza toate lectiile ca sa il obtii.'
              : 'Certificatul nu a putut fi incarcat. Incearca din nou mai tarziu.'}
          </p>
        </div>

        <div className="diploma-extra-actions">
          <Link to="/functionalpagelogin" className="diploma-action-btn">
            Inapoi la cursuri
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="diploma-page">

      <div className="diploma-success">
        <span className="diploma-success-icon">🎉</span>

        <h1>Felicitari!</h1>

        <p>
          Ai finalizat cu succes cursul <b>{certificate.course_name}</b>.
          Certificatul tau este gata.
        </p>
      </div>

      <Diploma certificateData={certificate} />

  <div className="diploma-extra-actions">



  <Link
    to="/check-certification"
    className="diploma-action-btn"
  >
    Verifica certificatul
  </Link>

</div>

    </div>
  );
};

export default DiplomaPage;
